<template>
  <span
    data-test-id="buttonIcon"
    :disabled="disabled"
    class="d-print-none"
    :class="{ 'button-icon': !disabled, 'button-icon-disabled': disabled }"
    v-resize="onResize"
  >
    <v-icon
      class="icon"
      :disabled="disabled"
      v-bind="$attrs"
      v-tooltip="{ openOnClick: true, text, disabled: !isMini }"
    ></v-icon>
    <span v-if="!isMini" class="text">{{ text }}</span>
  </span>
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES
import { ref } from 'vue'

// PROPS & EMITS
defineProps({
  disabled: { type: Boolean, default: false },
  text: { type: String, required: true }
})

// REACTIVE VARIABLES
const isMini = ref<boolean>(false)

// COMPUTED PROPERTIES

// LIFECYCLE HOOKS

// FUNCTIONS
const onResize = () => {
  isMini.value = window.innerWidth < 600
}
</script>

<style lang="scss" scoped>
.button-icon {
  max-width: 18rem;
  margin-right: 1rem;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.button-icon:hover,
.button-icon:focus-within {
  color: $color-main-primary;
}
.button-icon-disabled {
  margin-right: 1rem;
  color: $color-dark-56;
  cursor: default;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
  font-size: 0.75rem;
  margin-left: 0.25rem;
}
</style>
